<script lang="ts">

  import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "$lib/components/ui/dialog"
  import { Label } from "$lib/components/ui/label"
  import type { Info } from "../_types"

  type Props = {
    open?: boolean
    setOpen: (value: boolean) => void
    select: Info
  }
  let { open = false, setOpen, select }: Props = $props()

</script>

<Dialog
  open={open}
  onOpenChange={setOpen}>
  <DialogContent
    class="w-sm"
    onOpenAutoFocus={(event) => event.preventDefault()}>
    <DialogHeader>
      <DialogTitle>Informasi</DialogTitle>
      <DialogDescription></DialogDescription>
    </DialogHeader>
    <div class="space-y-3">
      <div>
        <Label>Nama</Label>
        <div class="text-desc">{select.name || "-"}</div>
      </div>
      <div>
        <Label>Tanggal</Label>
        <div class="text-desc font-mono">{select.datetime ? select.datetime.toDateFormat("dd MMMM yyyy") : "-"}</div>
      </div>
      <div>
        <Label>Sumber</Label>
        <div class="text-desc">{select.source || "-"}</div>
      </div>
      <!-- eslint-disable-next-line svelte/no-at-html-tags -->
      <div class="rounded-md bg-muted p-3">{@html select.content}</div>
    </div>
  </DialogContent>
</Dialog>
